import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
function slider() {

    /**** Einsatzgebiete Slider (area-slider)****/
    document.querySelectorAll('.area-slider').forEach(carousel => new Swiper(carousel, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next-area",
            prevEl: ".swiper-button-prev-area",
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            }
        }
    }));


    /**** Einsatzgebiete Slider (area-slider)****/
    document.querySelectorAll('.products-zubehoer-slider').forEach(carousel => new Swiper(carousel, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        grabCursor: true,
        pagination: {
            el: ".products-zubehoer-slider-swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next-products-zubehoer-slider",
            prevEl: ".swiper-button-prev-products-zubehoer-slider",
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 2,
            }
        }
    }));

}


export { slider }